namespace Matrix.Workflow {
    export interface TaskInstanceForm {
        WorkflowCode: Serenity.StringEditor;
        WorkflowInstanceId: Serenity.IntegerEditor;
        TaskCode: Serenity.StringEditor;
        StatusCode: Serenity.StringEditor;
        StartedWhen: Serenity.DateTimeEditor;
        FinishedWhen: Serenity.DateTimeEditor;
        C1: Serenity.StringEditor;
        C2: Serenity.StringEditor;
        C3: Serenity.StringEditor;
        C4: Serenity.StringEditor;
        C5: Serenity.StringEditor;
        C6: Serenity.StringEditor;
        C7: Serenity.StringEditor;
        C8: Serenity.StringEditor;
        C9: Serenity.StringEditor;
        C10: Serenity.StringEditor;
        B1: Serenity.BooleanEditor;
        B2: Serenity.BooleanEditor;
        B3: Serenity.BooleanEditor;
        B4: Serenity.BooleanEditor;
        B5: Serenity.BooleanEditor;
        B6: Serenity.BooleanEditor;
        B7: Serenity.BooleanEditor;
        B8: Serenity.BooleanEditor;
        B9: Serenity.BooleanEditor;
        B10: Serenity.BooleanEditor;
        N1: Serenity.IntegerEditor;
        N2: Serenity.IntegerEditor;
        N3: Serenity.IntegerEditor;
        N4: Serenity.IntegerEditor;
        N5: Serenity.IntegerEditor;
        N6: Serenity.IntegerEditor;
        N7: Serenity.IntegerEditor;
        N8: Serenity.IntegerEditor;
        N9: Serenity.IntegerEditor;
        N10: Serenity.IntegerEditor;
        F1: Serenity.DecimalEditor;
        F2: Serenity.DecimalEditor;
        F3: Serenity.DecimalEditor;
        F4: Serenity.DecimalEditor;
        F5: Serenity.DecimalEditor;
        F6: Serenity.DecimalEditor;
        F7: Serenity.DecimalEditor;
        F8: Serenity.DecimalEditor;
        F9: Serenity.DecimalEditor;
        F10: Serenity.DecimalEditor;
        D1: Serenity.DateTimeEditor;
        D2: Serenity.DateTimeEditor;
        D3: Serenity.DateTimeEditor;
        D4: Serenity.DateTimeEditor;
        D5: Serenity.DateTimeEditor;
        Txt1: Serenity.TextAreaEditor;
        Txt2: Serenity.TextAreaEditor;
        Txt3: Serenity.TextAreaEditor;
        Txt4: Serenity.TextAreaEditor;
        Txt5: Serenity.TextAreaEditor;
        Properties: Serenity.TextAreaEditor;
        Documents: TaskInstanceDocumentGrid;
        CorrelationId: Serenity.StringEditor;
        DurationMs: Serenity.StringEditor;
        StdOut: Serenity.TextAreaEditor;
        StdErr: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TaskInstanceForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.TaskInstance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaskInstanceForm.init)  {
                TaskInstanceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateTimeEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.TextAreaEditor;
                var w6 = TaskInstanceDocumentGrid;
                var w7 = StaticTextBlock;
                var w8 = ReadOnlyDateTime;

                Q.initFormType(TaskInstanceForm, [
                    'WorkflowCode', w0,
                    'WorkflowInstanceId', w1,
                    'TaskCode', w0,
                    'StatusCode', w0,
                    'StartedWhen', w2,
                    'FinishedWhen', w2,
                    'C1', w0,
                    'C2', w0,
                    'C3', w0,
                    'C4', w0,
                    'C5', w0,
                    'C6', w0,
                    'C7', w0,
                    'C8', w0,
                    'C9', w0,
                    'C10', w0,
                    'B1', w3,
                    'B2', w3,
                    'B3', w3,
                    'B4', w3,
                    'B5', w3,
                    'B6', w3,
                    'B7', w3,
                    'B8', w3,
                    'B9', w3,
                    'B10', w3,
                    'N1', w1,
                    'N2', w1,
                    'N3', w1,
                    'N4', w1,
                    'N5', w1,
                    'N6', w1,
                    'N7', w1,
                    'N8', w1,
                    'N9', w1,
                    'N10', w1,
                    'F1', w4,
                    'F2', w4,
                    'F3', w4,
                    'F4', w4,
                    'F5', w4,
                    'F6', w4,
                    'F7', w4,
                    'F8', w4,
                    'F9', w4,
                    'F10', w4,
                    'D1', w2,
                    'D2', w2,
                    'D3', w2,
                    'D4', w2,
                    'D5', w2,
                    'Txt1', w5,
                    'Txt2', w5,
                    'Txt3', w5,
                    'Txt4', w5,
                    'Txt5', w5,
                    'Properties', w5,
                    'Documents', w6,
                    'CorrelationId', w0,
                    'DurationMs', w0,
                    'StdOut', w5,
                    'StdErr', w5,
                    'CreatedBy', w7,
                    'CreatedWhen', w8,
                    'UpdatedBy', w7,
                    'UpdatedWhen', w8,
                    'Version', w7
                ]);
            }
        }
    }
}
